import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { IndoorHall } from '../models/models';

import { InfrastructureService } from './infrastructure.service';

@Injectable({
  providedIn: 'root',
})
export class IndoorHallService extends InfrastructureService<IndoorHall> {
  protected readonly endpoint: string = '/IndoorHalls';

  constructor(protected http: HttpClient) {
    super(http);
  }

}
